//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'card',
  props: {
    title: String,
    content: String,
    viewMore: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      showViewMore: false,
      toggle: false,
      viewMoreStr: this.$i18n.t('hotel.VIEW_MORE'),
    };
  },
  watch: {
    content(cur){
      if(cur && this.viewMore){
        setTimeout(() => {
          this.calcContentHeight();
        }, 500);
      }
    },
  },
  methods: {
    /** 展开/收起更多 */
    onToggleContent(){
      this.toggle = !this.toggle;

      if(this.toggle){
        this.viewMoreStr = this.$i18n.t('hotel.COLLAPSE');
      }else{
        this.viewMoreStr = this.$i18n.t('hotel.VIEW_MORE');
      }
    },

    /** 计算内容的高度 */
    calcContentHeight(){
      const h = this.$refs.contentHeight.offsetHeight;

      if(parseInt(h / 2) > 66){
        this.showViewMore = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Card/Card.vue